<template>
  <div>
    <SearchForm
      :searchForm="initParam"
      :searchFormTemp="searchFormTemp"
      :authBtn="'bbc:customer:page'"
      @normalSearch="normalSearch"
      @normalResetQuery="normalResetQuery"
      labelWidth="120px"
    >
      <el-button :loading="loading" slot="exportBtn" type="primary" @click="distributeExport" plain>导出</el-button>
    </SearchForm>
    <Table :data="listData" :options="listDataOptions"></Table>
    <Pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :pageData="initParam"
      :total="total"
    ></Pagination>
  </div>
</template>
<script>
import SearchForm from '@/components/layouts/SearchForm';
import Pagination from '@/components/layouts/Pagination';
import Table from '@/components/layouts/table';
import { myMixin } from '@/mixins/index';
import { enterprisePointDistributePage, enterprisePointDistributeExport } from '@/api/integralManage';
export default {
  mixins: [myMixin],
  components: {
    SearchForm,
    Pagination,
    Table,
  },

  data() {
    return {
      initParam: {
        pageNum: 1,
        pageSize: 10,
        param: {
          enterpriseId: '',
          operationId: '',
          userCardNo: '',
          startTime: '',
          endTime: '',
        },
      },
      total: 0,
      loading: false,
      searchFormTemp: [
        { lable: '批次号', name: 'operationId', type: 'input' },
        { lable: '操作时间起期', name: 'startTime', type: 'datePicker' },
        { lable: '操作时间止期', name: 'endTime', type: 'datePicker' },
        { lable: '证件号码', name: 'userCardNo', type: 'input' },
      ],
      listData: [],
      listDataOptions: [
        { prop: 'operationId', label: '批次号', basewidth: 200 },
        { prop: 'distributeCardType', label: '证件类型', dic: 'gen.identityType' },
        { prop: 'distributeCardNo', label: '证件号码', basewidth: 220 },
        { prop: 'distributePoints', label: '分配积分' },
        { prop: 'distributeValidTime', label: '积分有效期' },
        { prop: 'distributeCreateTime', label: '操作时间' },
        { prop: 'distributeCreateId', label: '操作人', dic: 'allUserDics', basewidth: 120 },
      ],
    };
  },
  methods: {
    init() {
      this.queryData(true);
    },
    async queryData(bool = true) {
      // 默认将当前页数归1HR
      if (bool) this.initParam.pageNum = 1;
      this.initParam.param.enterpriseId = this.$store.state.user.user.enterpriseId;
      let res = await enterprisePointDistributePage(this.initParam);
      this.listData = res.list;
      this.total = res.total;
    },
    clear() {
      this.initParam.param.operationId = '';
      this.initParam.param.startTime = '';
      this.initParam.param.endTime = '';
    },
    async distributeExport() {
      this.loading = true;
      this.initParam.param.enterpriseId = this.$store.state.user.user.enterpriseId;
      await enterprisePointDistributeExport('分配明细.xlsx', this.initParam.param)
       this.loading = false
    },
  },
};
</script>
<style lang="less" scoped>
</style>